import { useTranslate } from '@tolgee/react';
import DecorateTitle from 'components/DecorateTitle';
import SettingItemContainer from './SettingItemContainer';
import { Modal, Radio, Space } from 'antd';
import useSystem from 'hooks/business/system/useSystem';

export const QuitSetting = () => {
  const { t } = useTranslate();
  const {
    systemSetting: { closeType },
    handleCloseSettingChange,
  } = useSystem();

  const CloseTypeMap = {
    hidden: t('sys_setting_quit_hidden'),
    closeAndOffline: t('sys_setting_quit_offline'),
    close: t('sys_setting_quit_close'),
  };

  return (
    <>
      <DecorateTitle>{t('sys_setting_quit_title')}</DecorateTitle>
      <SettingItemContainer>
        <Radio.Group
          onChange={(e) => {
            const value = e.target.value as Chattt.SystemSettings['quitMode'];
            if (value === 'closeAndOffline') {
              Modal.confirm({
                content: t('sys_setting_quit_offline_msg'),
                onOk: () => {
                  handleCloseSettingChange(value);
                },
              });
            } else {
              handleCloseSettingChange(value);
            }
          }}
          value={closeType === 'default' ? 'hidden' : closeType}
        >
          <Space direction="vertical">
            {Object.entries(CloseTypeMap).map(([value, text]) => (
              <Radio key={value} value={value}>
                {text}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </SettingItemContainer>
    </>
  );
};
